import { useState, FormEvent, useEffect } from 'react';

const CONTACT_URL = 'https://readdy.ai/api/form/d7i08s7hkiob2r09iqv0';

const contactInfo = [
  {
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    value: '304 679 9009',
    href: 'https://wa.me/573046799009',
  },
  {
    icon: 'ri-phone-line',
    label: 'Teléfono de Contacto',
    value: '304 213 3550 - 312 581 9210',
    href: 'tel:+573125819210',
  },
  {
    icon: 'ri-mail-line',
    label: 'Correo',
    value: 'fundacion.frais@gmail.com',
    href: 'mailto:fundacion.frais@gmail.com',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Departamento',
    value: 'Petroriente, Giron - Santander, Colombia.',
    href: '#',
  },
  {
    icon: 'ri-government-line',
    label: 'NIT',
    value: '901846693-3',
    href: '#',
  },
];

const topics = [
  'Programas Educativos',
  'Alianzas Corporativas',
  'Voluntariado',
  'Donaciones',
  'Prensa y Medios',
  'Otro',
];

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [topic, setTopic] = useState(topics[0]);
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    if (!name || !email || !message) {
      setError('Por favor completa todos los campos requeridos.');
      return;
    }
    if (message.length > 500) {
      setError('El mensaje no puede superar los 500 caracteres.');
      return;
    }
    setLoading(true);
    try {
      const body = new URLSearchParams({ name, email, tema: topic, mensaje: message });
      await fetch(CONTACT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setError('Ocurrió un error. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      {/* Hero */}
      <section className="relative w-full min-h-[50vh] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=people%20having%20a%20meaningful%20conversation%20outdoors%20in%20green%20park%2C%20warm%20sunlight%2C%20Colombia%2C%20community%20connection%2C%20diverse%20group%2C%20high%20quality%20photography%2C%20warm%20tones%2C%20natural%20light&width=1920&height=700&seq=contact001&orientation=landscape"
            alt="Contacto Fundación Frais"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/50 to-transparent"></div>
        </div>
        <div className="relative z-10 w-full px-8 md:px-20 pb-20 pt-40">
          <p className="text-[#4caf7d] text-xs tracking-widest uppercase mb-4 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Hablemos
          </p>
          <h1
            className="text-5xl md:text-7xl font-bold text-white leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Estamos<br />
            <em className="not-italic text-[#4caf7d]">Aquí para Ti</em>
          </h1>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 md:py-32 px-8 md:px-20 bg-[#f7f5f2]">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Info */}
          <div className="lg:col-span-2 flex flex-col gap-8">
            <div>
              <p className="text-gray-400 text-xs tracking-widest uppercase mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Información de Contacto
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a3a2e] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Conectemos y<br />Creemos Cambio
              </h2>
              <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Ya sea que quieras implementar un programa en tu institución, hacer una alianza corporativa o simplemente saber más sobre nuestro trabajo, estamos listos para escucharte.
              </p>
            </div>

            <div className="flex flex-col gap-5">
              {contactInfo.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  rel="nofollow"
                  className="flex items-start gap-4 group cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#d4f1e8] flex-shrink-0 group-hover:bg-[#4caf7d] transition-colors duration-300">
                    <i className={`${item.icon} text-[#1a3a2e] group-hover:text-white text-lg transition-colors duration-300`}></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs tracking-wide uppercase mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      {item.label}
                    </p>
                    <p className="text-[#1a3a2e] text-sm font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      {item.value}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            {/* Social */}
            <div>
              <p className="text-gray-400 text-xs tracking-widest uppercase mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Síguenos
              </p>
              <div className="flex items-center gap-3">
                {[
                  { icon: 'ri-instagram-line', label: 'Instagram' },
                  { icon: 'ri-facebook-line', label: 'Facebook' },
                  { icon: 'ri-linkedin-line', label: 'LinkedIn' },
                ].map((s) => (
                  <a
                    key={s.label}
                    href="#"
                    rel="nofollow"
                    aria-label={s.label}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1a3a2e] text-white hover:bg-[#4caf7d] transition-colors duration-300 cursor-pointer"
                  >
                    <i className={`${s.icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden h-48">
              <iframe
                title="Ubicación Fundación Frais"
                src="https://www.google.com/maps?q=7.081595,-73.089233&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-3">
            {submitted ? (
              <div className="bg-white rounded-3xl p-16 text-center h-full flex flex-col items-center justify-center">
                <div className="w-20 h-20 flex items-center justify-center rounded-full bg-[#d4f1e8] mb-8">
                  <i className="ri-checkbox-circle-line text-4xl text-[#4caf7d]"></i>
                </div>
                <h3 className="text-3xl font-bold text-[#1a3a2e] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  ¡Mensaje Enviado!
                </h3>
                <p className="text-gray-500 text-base leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Gracias por contactarnos. Nuestro equipo te responderá en un plazo máximo de 48 horas hábiles.
                </p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                id="contact-form"
                className="bg-white rounded-3xl p-8 md:p-12 flex flex-col gap-6"
              >
                <div>
                  <p className="text-gray-400 text-xs tracking-widest uppercase mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Envíanos un Mensaje
                  </p>
                  <h3 className="text-2xl font-bold text-[#1a3a2e] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                    ¿En qué podemos ayudarte?
                  </h3>
                </div>

                {/* Topic */}
                <div>
                  <label className="block text-xs text-gray-500 mb-2 uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Tema de consulta
                  </label>
                  <div className="flex flex-wrap gap-2">
                    {topics.map((t) => (
                      <button
                        key={t}
                        type="button"
                        onClick={() => setTopic(t)}
                        className={`px-4 py-2 rounded-full text-xs font-semibold tracking-wide transition-all duration-200 cursor-pointer whitespace-nowrap ${
                          topic === t
                            ? 'bg-[#1a3a2e] text-white'
                            : 'bg-[#f0f7f4] text-[#1a3a2e] hover:bg-[#d4f1e8]'
                        }`}
                        style={{ fontFamily: "'Montserrat', sans-serif" }}
                      >
                        {t}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs text-gray-500 mb-2 uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      Nombre completo *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      placeholder="Tu nombre"
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 text-[#1a3a2e] text-sm focus:outline-none focus:border-[#4caf7d] transition-colors"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-2 uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      Correo electrónico *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder="tu@email.com"
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 text-[#1a3a2e] text-sm focus:outline-none focus:border-[#4caf7d] transition-colors"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs text-gray-500 mb-2 uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Mensaje *
                  </label>
                  <textarea
                    name="mensaje"
                    value={message}
                    onChange={(e) => {
                      if (e.target.value.length <= 500) setMessage(e.target.value);
                    }}
                    required
                    placeholder="Cuéntanos cómo podemos ayudarte..."
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 text-[#1a3a2e] text-sm focus:outline-none focus:border-[#4caf7d] transition-colors resize-none"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  />
                  <p className="text-xs text-gray-400 text-right mt-1">{message.length}/500</p>
                </div>

                {error && (
                  <div className="flex items-center gap-2 text-red-500 text-sm bg-red-50 rounded-xl px-4 py-3">
                    <i className="ri-error-warning-line"></i>
                    <span style={{ fontFamily: "'Montserrat', sans-serif" }}>{error}</span>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center justify-center gap-3 w-full py-4 rounded-full bg-[#1a3a2e] text-white font-semibold text-sm tracking-wider uppercase hover:bg-[#2d5a42] transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {loading ? 'Enviando...' : 'Enviar Mensaje'}
                  {!loading && <i className="ri-send-plane-line"></i>}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-white px-8 md:px-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-400 text-xs tracking-widest uppercase mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Preguntas Frecuentes
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1a3a2e]" style={{ fontFamily: "'Playfair Display', serif" }}>
              Resolvemos tus Dudas
            </h2>
          </div>
          <div className="flex flex-col gap-4">
            {[
              {
                q: '¿Cómo puedo implementar un programa de reciclaje en mi colegio?',
                a: 'Contáctanos a través del formulario o por teléfono. Nuestro equipo realizará una visita diagnóstica gratuita para diseñar un programa personalizado según las necesidades de tu institución.',
              },
              {
                q: '¿Las donaciones son deducibles de impuestos?',
                a: 'Sí. Fundación Frais está registrada como entidad sin ánimo de lucro. Emitimos certificados de donación que pueden ser utilizados para deducciones tributarias según la normativa colombiana.',
              },
              {
                q: '¿Cómo puedo ser voluntario de Fundación Frais?',
                a: 'Puedes postularte como voluntario a través de nuestro formulario de contacto seleccionando la opción "Voluntariado". Buscamos personas apasionadas por el medio ambiente y la educación.',
              },
              {
                q: '¿En qué ciudades tienen presencia?',
                a: 'Nuestra presencia está concentrada en Bucaramanga y el área metropolitana de Santander. Desde allí atendemos los 87 municipios del departamento con nuestros programas de reciclaje, madera plástica y educación ambiental.',
              },
            ].map((faq, i) => (
              <FaqItem key={i} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

function FaqItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-100 rounded-2xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-[#f7f5f2] transition-colors"
      >
        <span className="text-[#1a3a2e] font-semibold text-sm pr-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {question}
        </span>
        <i className={`ri-arrow-down-s-line text-[#4caf7d] text-xl flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}></i>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-48' : 'max-h-0'}`}>
        <p className="px-6 pb-5 text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {answer}
        </p>
      </div>
    </div>
  );
}
